import { Injectable } from '@angular/core';

declare var gtag: Function; // Declaração para evitar erro do TypeScript

@Injectable({
  providedIn: 'root'
})
export class GoogleTagService {

  constructor() { }

  sendEvent(eventName: string, eventParams: any) {
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, eventParams);
    } else {
      console.warn('Google Tag Manager não carregado.');
    }
  }
}
